import { render, staticRenderFns } from "./CharityProfileTemplate.vue?vue&type=template&id=4cc50cd3&scoped=true&"
import script from "./CharityProfileTemplate.vue?vue&type=script&lang=js&"
export * from "./CharityProfileTemplate.vue?vue&type=script&lang=js&"
import style0 from "./CharityProfileTemplate.vue?vue&type=style&index=0&id=4cc50cd3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc50cd3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
